import React from 'react';

function Frame() {
  return (
    <svg
      width="584"
      height="255"
      viewBox="0 0 584 255"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M552.348 0.25532C550.028 6.2828 547.714 12.3135 545.384 18.341C540.571 30.8032 535.775 43.275 530.892 55.7114C530.497 56.7133 529.654 57.7151 528.749 58.3066C508.256 71.6866 487.723 85.0117 467.201 98.3465C466.59 98.744 465.992 99.1674 464.88 99.9301C469.13 100.467 472.773 100.929 476.861 101.446C476.114 102.083 475.639 102.512 475.135 102.91C464.547 111.206 453.944 119.483 443.385 127.818C442.16 128.784 440.977 129.192 439.426 128.998C430.538 127.883 421.631 126.913 412.753 125.727C406.9 124.945 402.705 120.912 401.367 115.198C400.104 109.794 402.14 104.38 406.887 101.058C420.784 91.3301 434.72 81.657 448.643 71.9646C482.543 48.362 516.445 24.7595 550.345 1.16025C550.904 0.772423 551.466 0.384595 552.028 0C552.132 0.0840292 552.242 0.168059 552.348 0.25532Z"
        fill="#368ABD"
      />
      <path
        d="M518.081 157.399C514.002 156.895 509.926 156.394 505.848 155.89C505.689 155.709 505.531 155.531 505.373 155.35C505.832 155.121 506.339 154.956 506.74 154.652C518.346 145.878 529.922 137.068 541.57 128.351C542.388 127.74 543.739 127.478 544.782 127.595C553.751 128.584 562.703 129.718 571.669 130.759C577.26 131.408 582.024 135.477 583.446 140.936C584.893 146.501 582.903 152.18 578.084 155.493C565.47 164.157 552.801 172.741 540.145 181.344C504.513 205.567 468.885 229.784 433.253 254.001C432.936 254.217 432.6 254.405 431.834 254.88C433.353 251.347 434.662 248.264 436 245.194C443.117 228.84 450.208 212.477 457.424 196.169C457.977 194.922 459.276 193.823 460.488 193.083C479.123 181.684 497.8 170.356 516.468 159.006C517.043 158.657 517.599 158.275 518.161 157.91C518.132 157.739 518.106 157.571 518.081 157.399Z"
        fill="#368ABD"
      />
      <path
        d="M528.481 125.675C504.688 143.26 481.386 160.476 458.084 177.696C457.974 177.609 457.864 177.521 457.754 177.434C464.14 162.903 470.53 148.373 477.087 133.454C469.376 132.52 461.904 131.619 453.795 130.636C476.741 112.683 499.268 95.0595 521.791 77.436C521.901 77.5104 522.014 77.5847 522.124 77.6558C516.413 92.613 510.699 107.567 504.878 122.818C512.709 123.765 520.301 124.686 528.481 125.675Z"
        fill="#368ABD"
      />
      <path
        d="M151.348 0.25532C149.028 6.2828 146.714 12.3135 144.384 18.341C139.571 30.8032 134.775 43.275 129.892 55.7114C129.497 56.7133 128.654 57.7151 127.749 58.3066C107.256 71.6866 86.7234 85.0117 66.2009 98.3465C65.59 98.744 64.9921 99.1674 63.8804 99.9301C68.1303 100.467 71.7726 100.929 75.861 101.446C75.1144 102.083 74.6393 102.512 74.1351 102.91C63.5475 111.206 52.9436 119.483 42.385 127.818C41.1601 128.784 39.9773 129.192 38.426 128.998C29.5383 127.883 20.6312 126.913 11.7531 125.727C5.90019 124.945 1.70519 120.912 0.367188 115.198C-0.896482 109.794 1.13961 104.38 5.88726 101.058C19.7844 91.3301 33.7203 81.657 47.6433 71.9646C81.5426 48.362 115.445 24.7595 149.345 1.16025C149.904 0.772423 150.466 0.384595 151.028 0C151.132 0.0840292 151.242 0.168059 151.348 0.25532Z"
        fill="#E5152D"
      />
      <path
        d="M117.081 157.399C113.002 156.895 108.926 156.394 104.848 155.89C104.689 155.709 104.531 155.531 104.373 155.35C104.832 155.121 105.339 154.956 105.74 154.652C117.346 145.878 128.922 137.068 140.57 128.351C141.388 127.74 142.739 127.478 143.782 127.595C152.751 128.584 161.703 129.718 170.669 130.759C176.26 131.408 181.024 135.477 182.446 140.936C183.893 146.501 181.903 152.18 177.084 155.493C164.47 164.157 151.801 172.741 139.145 181.344C103.513 205.567 67.8847 229.784 32.253 254.001C31.9363 254.217 31.6002 254.405 30.8342 254.88C32.3532 251.347 33.6621 248.264 35.0001 245.194C42.1168 228.84 49.2075 212.477 56.4244 196.169C56.977 194.922 58.2762 193.823 59.4882 193.083C78.1233 181.684 96.8004 170.356 115.468 159.006C116.043 158.657 116.599 158.275 117.161 157.91C117.132 157.739 117.106 157.571 117.081 157.399Z"
        fill="#E5152D"
      />
      <path
        d="M127.481 125.675C103.688 143.26 80.3856 160.476 57.0836 177.696C56.9738 177.609 56.8639 177.521 56.754 177.434C63.1402 162.903 69.5297 148.373 76.0872 133.454C68.3759 132.52 60.9037 131.619 52.7949 130.636C75.7414 112.683 98.2677 95.0595 120.791 77.436C120.901 77.5104 121.014 77.5847 121.124 77.6558C115.413 92.613 109.699 107.567 103.878 122.818C111.709 123.765 119.301 124.686 127.481 125.675Z"
        fill="#E5152D"
      />
      <rect
        x="88"
        y="54"
        width="411"
        height="150"
        rx="24"
        fill="black"
        stroke="url(#paint0_linear_935_1729)"
        strokeWidth="12"
      />
      <defs>
        <linearGradient
          id="paint0_linear_935_1729"
          x1="82"
          y1="129"
          x2="495.5"
          y2="129"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E5152D" />
          <stop offset="1" stopColor="#368ABD" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default Frame;
